<template lang="pug">
.networkList
  .row
    .col-md-10.col-md-offset-1
      table.table.table-hover
        thead
          tr
            th
            th
              .input-group
                input.form-control.input-sm(type='text' v-model='filtered' :placeholder='$options.filters.translate("Find in network description", lang)' @keydown.esc='cancelFilter()')
                .input-group-addon.input-sm(@click='cancelFilter()' v-tooltip.bottom='$options.filters.translate("Clear filter", lang)')
                  i.fa.fa-xs.fa-times-circle.text-warning(aria-hidden='true')
            th
            th
            th
          tr
            th(style="width: 20%") {{$options.filters.translate('Name', lang)}}
            th(style="width: 25%") {{$options.filters.translate('Description', lang)}}
            th(style="width: 15%") {{$options.filters.translate('Lang', lang)}}
            th(style="width: 10%") {{$options.filters.translate('Timezone', lang)}}
            th
              button.btn.btn-success.btn-sm.btn-block(@click.prevent='$router.push({name: "networkEdit"})') {{$options.filters.translate('add', lang)}}
        tbody
          tr.network(v-for='(network, index) in filteredNetworks', :key='index')
            td {{network.name}}
            td {{network.description}}
            td {{network.lang}}
            td {{network.timezone}}
            td
              button.btn.btn-default.btn-sm.btn-block(@click.prevent='$router.push({name: "networkEdit", params: {networkId: network.id}})') {{$options.filters.translate('edit', lang)}}
</template>
<script>
export default {
  name: 'networkList',
  props: ['lang'],
  data () {
    return {
      networks: [],
      filtered: ''
    }
  },
  computed: {
    filteredNetworks () {
      return this.networks.filter(network => {
        return this.checkFilter(network.description)
      })
    }
  },
  methods: {
    checkFilter (description) {
      if (this.filtered.length < 1) {
        return true
      }
      if (description == null) {
        return false
      }
      if (description.toLowerCase().search(this.filtered.toLowerCase()) >= 0) {
        return true
      }
      return false
    },
    cancelFilter () {
      this.filtered = ''
    },
    getNetworks () {
      this.$http.get(`network`)
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.$store.commit('SET_LOADER', false)
          this.networks = data
        })
    },
    activate (id, direction) {
      this.$store.commit('SET_LOADER', true)
      this.$http.post('user/activate', {id, direction})
        .then(response => {
          if (response.status === 200) {
            this.$notify(this.$options.filters.translate('User status has been changed', this.lang), 'success')
          } else {
            this.$notify(this.$options.filters.translate('Error', this.lang), 'error')
          }
          this.getNetworks()
        })
    },
    showNetwork (userNetworks, id, index) {
      return this.withComma(userNetworks, this.networks.find(el => el.id === id).name, index)
    },
    azure (val) {
      return (val) ? 'Azure' : ''
    },
    withComma (all, el, index) {
      if (index !== all.length - 1) {
        return `${el}, `
      } else {
        return el
      }
    }
  },
  created () {
    this.getNetworks()
  }
}
</script>
<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/network/NetworkList.vue